import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SelectPracticeTable from "components/tables/SelectPracticeTable";

const SelectPractice = () => {
  const [select, setSelect] = useState("");
  const navigate = useNavigate();
  const practices = useSelector((state) => state.auth.authData?.practices);
  const aryData = practices?.map((el, index) => {
    return {
      id: index,
      practice_id: el.practice_id,
      practice_name: el.practice_name,
      claim_type: el.claim_type,
    };
  });
  const dispatch = useDispatch();

  if (!practices || practices.length === 0) {
    return (
      <Modal open={true} onClose={() => {}}>
        <div className="sel-practice-modal">
          <h3>
            There is no practice available.
            <br />
            Please make sure there is practice available.
          </h3>
          <button
            className="sel-practice-btn"
            onClick={() => navigate("/login")}
          >
            Login
          </button>
        </div>
      </Modal>
    );
  }
  return (
    <Modal open={true} onClose={() => {}}>
      <div className="upload-dictation-modal">
        <h3 style={{ textAlign: "center" }}>Select Practice</h3>
        <SelectPracticeTable
          setSelect={setSelect}
          select={select}
          dispatch={dispatch}
          aryData={aryData}
        />
      </div>
    </Modal>
  );
};

export default SelectPractice;
